export function toSnakeCase(str) {
    str = str.toLowerCase().replace(/\W+/g, '_');
    return str;
}

export function stripTrailingSlash(str) {
    return str.endsWith('/') ? str.slice(0, -1) : str;
}

function slashSplice(str) {
    const words = str.split(' ');
    const spliceIndex = words.length / 2;
    words.splice(spliceIndex, 0, '/');
    return words.join(' ');
}

export function formatCommunityName(str) {
    if (!str) {
        return str;
    }

    let formattedName = '';
    let formattedWords = str
        .replace(/_/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1));

    if (formattedWords.length > 1) {
        formattedName = formattedWords.join(' ');
    } else {
        formattedName = formattedWords[0];
    }

    if (
        formattedName === 'Buena Vista Ashbury Heights' ||
        formattedName === 'Lakeshore Lakeside' ||
        formattedName === 'Van Ness Civic Center'
    ) {
        formattedName = slashSplice(formattedName);
    } else if (formattedName === 'St Francis Wood') {
        formattedName = 'St. Francis Wood';
    }

    return formattedName;
}

export function truncate(str, count) {
    if (str.length > count) {
        str = str.slice(0, count);
        str += '...';
    }

    return str;
}



// WEBPACK FOOTER //
// ./src/common/utils/stringUtils.js